import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import type { RootStateType } from "State/Store";
import { Resources, useResource } from "Translations/Resources";
import { isAuthenticated } from "Utils/AuthUtils";
import { useSelector } from "react-redux";

export const ModuleLoadingFallback = () => {
  const { user } = useSelector((e: RootStateType) => e.auth);
  const { t } = useResource();

  if (!isAuthenticated(user)) {
    return null;
  }

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.Dashboard)}>
      <StyledPageWrapper>
        <div className="left-content" />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
